import React from "react";
import { observer } from "mobx-react";
import { getCurrentCulture } from "@utils";

export default observer(function StatisticsIFrame(props: {
	eStatId: string;
	tStatId: string;
}) {
	const srcUrl = `https://s5.sir.sportradar.com/tipwin/${getCurrentCulture()}${
		props.tStatId != null && props.tStatId != ""
			? `/season/${props.tStatId}`
			: `/match/${props.eStatId}`
	}`;

	return (
		<iframe
			id="statistics-frame"
			className="popup--full__iframe"
			src={srcUrl}
		/>
	);
});
